(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["electric-usage-calculator"] && !Shopify.designMode) return;
  try {
    class ElectricUsageCalculator extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('.electric-calc__form');
      this.form.addEventListener('submit', this.#onSubmit);
      this.form.addEventListener('reset', this.#onReset);
    }

    disconnectedCallback() {
      this.form.removeEventListener('submit', this.#onSubmit);
      this.form.removeEventListener('reset', this.#onReset);
    }

    #onSubmit = (event) => {
      event.preventDefault();
      const data = new FormData(this.form);

      const quantity = Number(data.get('quantity'));
      const voltage = Number(data.get('voltage'));
      const amps = Number(data.get('amps'));
      const hours = Number(data.get('hours'));
      const rate = Number(data.get('rate'));
      const inflationPct = Number(data.get('inflation'));

      if (
        ![quantity, voltage, amps, hours, rate, inflationPct].every(Number.isFinite) ||
        quantity <= 0 ||
        amps <= 0
      ) {
        return;
      }

      const inflation = inflationPct / 100;
      const watts = voltage * amps;
      const dailyKwh = (watts * quantity * hours) / 1000;
      const dailyCost = dailyKwh * rate;

      const monthKwh = dailyKwh * 30;
      const monthCost = dailyCost * 30;

      const year1Kwh = dailyKwh * 365;
      const year1Cost = dailyCost * 365;

      const projection = (years) => {
        let kwh = 0;
        let cost = 0;
        for (let y = 0; y < years; y++) {
          kwh += dailyKwh * 365;
          cost += dailyCost * 365 * Math.pow(1 + inflation, y);
        }
        return { kwh, cost };
      };

      const year5 = projection(5);
      const year10 = projection(10);

      const formatKwh = (value) => `${value.toLocaleString(undefined, { maximumFractionDigits: value < 100 ? 2 : 0 })} kWh`;
      const formatCost = (value) => `$${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

      this.#renderResults({
        'daily-kwh': formatKwh(dailyKwh),
        'daily-cost': formatCost(dailyCost),
        'month-kwh': formatKwh(monthKwh),
        'month-cost': formatCost(monthCost),
        'year1-kwh': formatKwh(year1Kwh),
        'year1-cost': formatCost(year1Cost),
        'year5-kwh': formatKwh(year5.kwh),
        'year5-cost': formatCost(year5.cost),
        'year10-kwh': formatKwh(year10.kwh),
        'year10-cost': formatCost(year10.cost),
      });
    };

    #onReset = () => {
      requestAnimationFrame(() => this.#renderResults(null));
    };

    #renderResults(values) {
      const cells = this.querySelectorAll('[data-result]');
      for (const cell of cells) {
        const key = cell.dataset.result;
        cell.textContent = values ? values[key] : '—';
      }
    }
  }

  if (!customElements.get('electric-usage-calculator')) {
    customElements.define('electric-usage-calculator', ElectricUsageCalculator);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["interactive-contact-form"] && !Shopify.designMode) return;
  try {
    class InteractiveContactForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.fields = Array.from(this.querySelectorAll('.form-field'));
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitLabelDefault = this.submitButton ? this.submitButton.textContent.trim() : '';

      this.controls = [];
      for (const field of this.fields) {
        const control = field.querySelector('input, select, textarea');
        if (!control) continue;
        this.controls.push([field, control]);
        this.#syncValue(field, control);
        control.addEventListener('input', () => {
          this.#syncValue(field, control);
          if (field.classList.contains('is-invalid')) this.#validateField(field, control);
        });
        control.addEventListener('change', () => this.#syncValue(field, control));
        control.addEventListener('focus', () => field.classList.add('is-focused'));
        control.addEventListener('blur', () => {
          field.classList.remove('is-focused');
          this.#validateField(field, control);
        });
      }

      if (this.form) {
        this.form.addEventListener('submit', this.#onSubmit);
      }
    }

    disconnectedCallback() {
      if (this.form) this.form.removeEventListener('submit', this.#onSubmit);
    }

    #syncValue(field, control) {
      const hasValue = control.value != null && String(control.value).trim() !== '';
      field.classList.toggle('has-value', hasValue);
    }

    #validateField(field, control) {
      const valid = control.checkValidity();
      field.classList.toggle('is-invalid', !valid);
      const error = field.querySelector('.form-field__error');
      if (error) error.textContent = valid ? '' : control.validationMessage;
      control.setAttribute('aria-invalid', valid ? 'false' : 'true');
      return valid;
    }

    #onSubmit = (event) => {
      let firstInvalid = null;
      for (const [field, control] of this.controls) {
        const valid = this.#validateField(field, control);
        if (!valid && !firstInvalid) firstInvalid = control;
      }

      if (firstInvalid) {
        event.preventDefault();
        firstInvalid.focus();
        return;
      }

      if (this.submitButton) {
        this.submitButton.disabled = true;
        this.submitButton.classList.add('is-loading');
        this.submitButton.textContent = this.dataset.loadingLabel || this.submitLabelDefault;
      }
    };
  }

  if (!customElements.get('interactive-contact-form')) {
    customElements.define('interactive-contact-form', InteractiveContactForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pond-sizing-selector"] && !Shopify.designMode) return;
  try {
    class PondSizingSelector extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.pond-selector__tab'));
      this.panels = Array.from(this.querySelectorAll('.pond-selector__panel'));

      const selectedTab = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') ?? this.tabs[0];
      if (selectedTab) this.#select(selectedTab.id);

      this.addEventListener('click', this.#onClick);
      this.addEventListener('keydown', this.#onKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#onClick);
      this.removeEventListener('keydown', this.#onKeydown);
    }

    #onClick = (event) => {
      const tab = event.target.closest('.pond-selector__tab');
      if (!tab || !this.contains(tab)) return;

      event.preventDefault();
      this.#select(tab.id);
    };

    #onKeydown = (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      const currentIndex = this.tabs.findIndex((tab) => tab === event.target);
      if (currentIndex === -1) return;

      event.preventDefault();
      let nextIndex;
      if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.tabs.length - 1;
      } else {
        const delta = event.key === 'ArrowRight' ? 1 : -1;
        nextIndex = (currentIndex + delta + this.tabs.length) % this.tabs.length;
      }
      const nextTab = this.tabs[nextIndex];
      nextTab.focus();
      this.#select(nextTab.id);
    };

    #select(tabId) {
      for (const tab of this.tabs) {
        const selected = tab.id === tabId;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      }

      for (const panel of this.panels) {
        panel.hidden = panel.getAttribute('aria-labelledby') !== tabId;
      }
    }
  }

  if (!customElements.get('pond-sizing-selector')) {
    customElements.define('pond-sizing-selector', PondSizingSelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pond-volume-calculator"] && !Shopify.designMode) return;
  try {
    class PondVolumeCalculator extends HTMLElement {
    connectedCallback() {
      this.forms = Array.from(this.querySelectorAll('[data-pond-calc]'));
      for (const form of this.forms) {
        form.addEventListener('submit', this.#onSubmit);
        form.addEventListener('reset', this.#onReset);
      }
    }

    disconnectedCallback() {
      for (const form of this.forms) {
        form.removeEventListener('submit', this.#onSubmit);
        form.removeEventListener('reset', this.#onReset);
      }
    }

    #onSubmit = (event) => {
      event.preventDefault();
      const form = event.currentTarget;
      const data = new FormData(form);
      const depth = Number(data.get('depth'));

      let areaSqFt;
      if (form.dataset.pondCalc === 'round') {
        const diameter = Number(data.get('diameter'));
        areaSqFt = Math.PI * Math.pow(diameter / 2, 2);
      } else {
        const length = Number(data.get('length'));
        const width = Number(data.get('width'));
        areaSqFt = length * width;
      }

      if (!Number.isFinite(areaSqFt) || !Number.isFinite(depth) || areaSqFt <= 0 || depth <= 0) {
        return;
      }

      const surfaceAcres = areaSqFt / 43560;
      const acreFeet = surfaceAcres * depth;
      const volumeCuFt = areaSqFt * depth;
      const gallons = volumeCuFt * 7.48052;

      this.#renderResults(form, {
        area: `${Math.round(areaSqFt).toLocaleString()} sq ft`,
        acres: surfaceAcres.toFixed(2),
        'acre-feet': acreFeet.toFixed(2),
        gallons: `${Math.round(gallons).toLocaleString()} gal`,
      });
    };

    #onReset = (event) => {
      const form = event.currentTarget;
      requestAnimationFrame(() => this.#renderResults(form, null));
    };

    #renderResults(form, values) {
      const dds = form.querySelectorAll('[data-result]');
      for (const dd of dds) {
        const key = dd.dataset.result;
        dd.textContent = values ? values[key] : '—';
      }
    }
  }

  if (!customElements.get('pond-volume-calculator')) {
    customElements.define('pond-volume-calculator', PondVolumeCalculator);
  }
  } catch(e) { console.error(e); }
})();

})();
